import axios from 'axios';
import { authService } from '../services/authService';

// Create axios instance with default configuration
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 120000, // 120 seconds (2 minutes) - increased from 10 seconds for AI training generation
});

// Request interceptor to add headers
api.interceptors.request.use(
  (config) => {
    // Add Authorization header if token exists
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    // Company switch header (superuser context only) - backend validates permissions
    if (token) {
      try {
        const activeCompanyId = localStorage.getItem('activeCompanyId');
        if (activeCompanyId) {
          config.headers['X-Company-ID'] = activeCompanyId;
        }
      } catch {}
    }

    // Only set Content-Type for non-FormData requests
    if (config.method !== 'get' && config.method !== 'delete') {
      // Don't override Content-Type if it's FormData (let browser set the boundary)
      if (!(config.data instanceof FormData)) {
        config.headers['Content-Type'] = 'application/json';
      } else {
        // Explicitly remove any existing Content-Type for FormData
        delete config.headers['Content-Type'];
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Enhanced error handling
    if (error?.response?.status === 401) {
      console.warn('Authentication required - redirecting to login');
      // Clear token and redirect to login
      authService.logout();
      window.location.href = '/login';
    } else if (error?.response?.status === 403) {
      console.warn('Access forbidden - insufficient permissions');
    } else if (error?.response?.status === 500) {
      console.error('Server error:', error.response.data);
    } else if (error?.code === 'NETWORK_ERROR' || !error?.response) {
      console.error('Network error:', error.message);
    }

    // Log error details in development
    if (process.env.NODE_ENV === 'development') {
      console.error('API Error:', {
        status: error?.response?.status,
        statusText: error?.response?.statusText,
        data: error?.response?.data,
        message: error?.message,
        config: {
          url: error?.config?.url,
          method: error?.config?.method,
        },
      });
    }

    return Promise.reject(error);
  }
);

export default api;
